var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryChallanFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 4.17871C4.33398 3.92249 4.23186 3.67637 4.05078 3.49512C3.86985 3.31419 3.6229 3.21199 3.36621 3.21191C3.11025 3.21191 2.86517 3.31354 2.68359 3.49512C2.50231 3.6764 2.40039 3.92233 2.40039 4.17871V5.84473C2.40039 5.88009 2.41445 5.91445 2.43945 5.93945C2.46437 5.96428 2.49804 5.97843 2.5332 5.97852H4.33398V4.17871ZM16.5664 13.4785H17.5332C17.9399 13.4785 18.3306 13.6402 18.6182 13.9277C18.9055 14.2153 19.0664 14.6052 19.0664 15.0117V15.8447C19.0664 16.4723 18.8178 17.0747 18.374 17.5186C17.9302 17.9624 17.3279 18.2119 16.7002 18.2119H6.7002C6.07252 18.2119 5.4702 17.9624 5.02637 17.5186C4.58263 17.0747 4.33398 16.4723 4.33398 15.8447V7.37793H2.5332C2.12673 7.37784 1.73668 7.21706 1.44922 6.92969C1.16166 6.64213 1 6.25139 1 5.84473V4.17871C1 3.55103 1.24952 2.94872 1.69336 2.50488C2.08144 2.1168 2.59001 1.8771 3.13184 1.82324L3.36621 1.81152H14.1992C14.8269 1.81152 15.4292 2.06105 15.873 2.50488C16.3168 2.94871 16.5664 3.5511 16.5664 4.17871V13.4785Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13672 10.7185L9.80339 9.21851L8.13672 7.71851",
    stroke: "#575757",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2148 10.7185L12.8815 9.21851L11.2148 7.71851",
    stroke: "#575757",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryChallanFilledV2);
export default __webpack_public_path__ + "static/media/deliveryChallanFilledV2.e2570d1cc4a46a459833580d0842dad5.svg";
export { ForwardRef as ReactComponent };